import jQuery from 'jquery';

export const bookieSelectionConfig = {
    onInit(bookie) {
        jQuery(document).on('bookieChanged.BOOKMAKER', (event, feedName) => {
            if (!feedName) {
                return;
            }
            bookie.setBookieUIByFeedName(feedName);
        });
    },
    onBookieSelection(bookie, selectedBookie) {
        jQuery(document).trigger('bookieChanged.BOOKMAKER', bookie.config.bookies[selectedBookie].feed);
    }
};



// WEBPACK FOOTER //
// ./lib/js/modules/bookieSelection/bookieSelection.config.js